import { IDocument, ObjectValues } from '../common';

export const SOURCE_STATUS = {
  PENDING: 'pending',
  NO_SPACE: 'no_space',
  FAILED: 'failed',
  INDEXED: 'indexed',
} as const;

export type SourceStatus = (typeof SOURCE_STATUS)[keyof typeof SOURCE_STATUS];

export const SOURCE_STATUS_DISPLAY: Record<SourceStatus, string> = {
  [SOURCE_STATUS.PENDING]: 'Pending',
  [SOURCE_STATUS.NO_SPACE]: 'No Space',
  [SOURCE_STATUS.FAILED]: 'Failed',
  [SOURCE_STATUS.INDEXED]: 'Indexed',
} as const;

export interface ISource extends IDocument {
  id: string;
  status: SourceStatus;
  source: string;
  url: string;
  characters: number;
  type: string;
}

export const FREQUENCY = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
} as const;

export type Frequency = ObjectValues<typeof FREQUENCY>;

export const FREQUENCY_DISPLAY: Record<Frequency, string> = {
  [FREQUENCY.DAILY]: 'Daily',
  [FREQUENCY.WEEKLY]: 'Weekly',
  [FREQUENCY.MONTHLY]: 'Monthly',
};

export const DAYS = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday',
} as const;

export type Day = (typeof DAYS)[keyof typeof DAYS];

export const FREQUENCY_OPTIONS: Array<{ value: Frequency; label: string }> = [
  {
    value: FREQUENCY.DAILY,
    label: 'Daily',
  },
  {
    value: FREQUENCY.WEEKLY,
    label: 'Weekly',
  },
  {
    value: FREQUENCY.MONTHLY,
    label: 'Monthly',
  },
];

export const DAY_OPTIONS: Array<{ value: Day; label: string }> = [
  {
    value: DAYS.MONDAY,
    label: 'Monday',
  },
  {
    value: DAYS.TUESDAY,
    label: 'Tuesday',
  },
  {
    value: DAYS.WEDNESDAY,
    label: 'Wednesday',
  },
  {
    value: DAYS.THURSDAY,
    label: 'Thursday',
  },
  {
    value: DAYS.FRIDAY,
    label: 'Friday',
  },
  {
    value: DAYS.SATURDAY,
    label: 'Saturday',
  },
  {
    value: DAYS.SUNDAY,
    label: 'Sunday',
  },
];
